module.exports = __webpack_public_path__ + "img/thumb_up@3x.a1fac0b3.png";